import { getBookCover } from './bookCovers';

/**
 * 书籍库数据
 * difficulty: '入门' | '进阶' — 唯一的分类维度
 */
const books = [
  {
    id: 'japanese-candlestick',
    title: '日本蜡烛图技术',
    author: '史蒂夫·尼森',
    cover: getBookCover('japanese-candlestick'),
    difficulty: '入门',
    summary: '介绍蜡烛图（K线）的基本形态与实战应用，是技术分析的入门必读。',
    highlights: `## 核心精华\n\n### 1. 蜡烛图的构成\n每根蜡烛线由 **开盘价、收盘价、最高价、最低价** 四个价格构成。实体部分代表开盘与收盘之间的价格区间，上下影线代表盘中的极端价格。\n\n### 2. 关键反转形态\n- **锤子线**：出现在下跌趋势底部，下影线长、实体小，暗示多方反攻\n- **吞没形态**：当前蜡烛实体完全"吞没"前一根，是强烈的趋势反转信号\n- **启明星 / 黄昏星**：三根蜡烛组成的反转组合，可靠性较高\n- **十字星**：开盘≈收盘，代表市场犹豫不决，常出现在趋势转折点\n\n### 3. 实战原则\n> 不要孤立地看单根蜡烛线，要结合 **趋势背景** 和 **支撑/阻力位** 综合判断。\n\n- 蜡烛图是 **确认工具**，不是预测工具\n- 在关键支撑/阻力位出现的反转信号更有价值\n- 配合成交量分析，信号更可靠\n\n### 4. 风险管理\n再完美的形态也不能保证 100% 胜率。尼森反复强调：**设置止损**、**控制仓位**，比识别形态更重要。`,
  },
  {
    id: 'technical-analysis',
    title: '金融市场技术分析',
    author: '约翰·墨菲',
    cover: getBookCover('technical-analysis'),
    difficulty: '进阶',
    summary: '技术分析的"百科全书"，系统讲解道氏理论、趋势、形态、指标等核心概念。',
    highlights: `## 核心精华\n\n### 1. 技术分析的三大假设\n1. **市场行为包容消化一切**：所有信息都已反映在价格中\n2. **价格以趋势方式演变**：趋势是你的朋友\n3. **历史会重演**：人性不变，图表形态反复出现\n\n### 2. 趋势分析\n- **上升趋势**：更高的高点 + 更高的低点\n- **下降趋势**：更低的高点 + 更低的低点\n- **趋势线**：至少需要两个点确认，第三个点接触后趋势线才有效\n\n### 3. 核心技术指标\n| 指标 | 用途 | 关键用法 |\n|------|------|---------|\n| 移动平均线 (MA) | 判断趋势方向 | 金叉/死叉信号 |\n| RSI | 判断超买超卖 | >70 超买，<30 超卖 |\n| MACD | 趋势+动量 | 零轴上方为多头市场 |\n| 布林带 | 波动率 | 收窄后常有大行情 |\n\n### 4. 交易量验证原则\n> 交易量是价格的"确认者"。价格上涨 + 量增 = 健康上涨；价格上涨 + 量缩 = 需要警惕。\n\n### 5. 多时间框架分析\n先看大周期定方向，再看小周期找入场点。**不要在小周期里迷失了大趋势。**`,
  },
  {
    id: 'trading-psychology',
    title: '交易心理分析',
    author: '马克·道格拉斯',
    cover: getBookCover('trading-psychology'),
    difficulty: '进阶',
    summary: '揭示交易者的心理陷阱，帮助建立概率思维和纪律化交易。',
    highlights: `## 核心精华\n\n### 1. 交易的本质是概率游戏\n> 大多数人亏钱不是因为没有好策略，而是因为 **无法一致性地执行策略**。\n\n### 2. 五个基本事实\n1. **任何事情都可能发生** —— 市场不需要理由\n2. **为了赚钱，你不需要知道下一步会怎样** —— 管理风险即可\n3. **任何被定义为"优势"的形态，产生的盈亏呈现随机分布**\n4. **优势只是表明一件事发生的概率高于另一件事** —— 不是确定性\n5. **市场中的每一刻都是独一无二的**\n\n### 3. 自我破坏的根源\n- 害怕错过 → 追涨杀跌\n- 害怕亏损 → 不设止损，死扛\n- 害怕犯错 → 不敢入场\n- 害怕成功 → 赚了又亏回去\n\n### 4. 建立纪律的核心\n1. 定义你的交易规则\n2. **像机器人一样执行**，不受情绪干扰\n3. 记录每一笔交易和当时的心态\n4. 关注 **过程** 而非 **结果**\n\n> 持续盈利的交易者不是在分析市场，而是在管理自己。`,
  },
  {
    id: 'intelligent-investor',
    title: '聪明的投资者',
    author: '本杰明·格雷厄姆',
    cover: getBookCover('intelligent-investor'),
    difficulty: '入门',
    summary: '价值投资的奠基之作，巴菲特称之为"有史以来最好的投资书籍"。',
    highlights: `## 核心精华\n\n### 1. 投资与投机的区别\n> 投资操作是以深入分析为基础，确保本金安全，并获得适当的回报。不符合这些要求的操作就是投机。\n\n### 2. "市场先生"寓言\n想象你和一个叫"市场先生"的人合伙做生意。他每天都会报一个价格，情绪波动极大。**你可以选择忽略他，也可以利用他的情绪。**\n\n### 3. 两种投资策略\n- **防御型投资者**：分散买入优质蓝筹股 + 债券，追求稳健\n- **进取型投资者**：在市场恐慌时买入被低估的股票\n\n### 4. 安全边际\n> 用 4 毛钱买价值 1 块钱的东西。安全边际越大，犯错的代价越小。\n\n### 5. 核心原则\n- 股票不仅仅是代码，它代表对一家企业的部分所有权\n- 市场是来为你服务的，不是来指导你的\n- 未来的价格没有人能预测，但你可以控制自己的行为`,
  },
  {
    id: 'market-wizards',
    title: '金融怪杰',
    author: '杰克·施瓦格',
    cover: getBookCover('market-wizards'),
    difficulty: '入门',
    summary: '采访华尔街顶级交易员的交易哲学与实战经验，了解成功交易者的共同特质。',
    highlights: `## 核心精华\n\n### 1. 成功交易者的共同特质\n- 都有 **明确的交易方法**，且严格遵循\n- 都极其重视 **风险管理**，止损毫不犹豫\n- 都经历过重大亏损，但从中吸取了教训\n- 都有 **耐心**，等待高胜率的机会\n\n### 2. 关键教训\n> 重要的不是你对的时候赚了多少，而是你错的时候亏了多少。\n\n### 3. 交易理念精华\n- **趋势跟踪**：让利润奔跑，截断亏损\n- **逆势交易**：在极端情绪中反向操作\n- **套利思维**：寻找市场定价的低效\n\n### 4. 给普通投资者的建议\n1. 找到适合自己的交易方法（别人的方法不一定适合你）\n2. 永远不要冒超过账户 1-2% 的风险在单笔交易上\n3. 保持交易日志，持续复盘`,
  },
  {
    id: 'reminiscences-stock-operator',
    title: '股票作手回忆录',
    author: '埃德温·勒菲弗',
    cover: getBookCover('reminiscences-stock-operator'),
    difficulty: '入门',
    summary: '以传奇交易员杰西·利弗莫尔为原型的半自传小说，充满交易智慧。',
    highlights: `## 核心精华\n\n### 1. 耐心等待\n> 华尔街没有新鲜事。因为投机像山岳一样古老，股市今天发生的事情，过去曾经发生过，将来也会再次发生。\n\n### 2. 趋势是你的朋友\n> 赚大钱的秘诀不在于频繁交易，而在于 **坐得住**。牛市中你要做的就是买入并持有。\n\n### 3. 截断亏损\n> 我之所以能赚大钱，靠的不是我的想法，而是我的 **坐功**。懂得拿住盈利头寸才是关键。\n\n### 4. 人性的弱点\n- 贪婪和恐惧是永恒的敌人\n- 人们总是在应该害怕的时候贪婪，在应该贪婪的时候害怕\n- 股票不会因为你需要它涨就涨\n\n### 5. 纪律\n> 在你能做到在市场证明你是对的之前不交易之前，你不可能在这个游戏中获胜。`,
  },
  {
    id: 'price-action',
    title: '价格行为交易',
    author: '阿尔·布鲁克斯',
    cover: getBookCover('price-action'),
    difficulty: '进阶',
    summary: '深入讲解裸K交易法，不依赖任何指标，纯粹通过价格行为判断市场方向。',
    highlights: `## 核心精华\n\n### 1. 什么是价格行为\n> 价格行为 = 蜡烛图 + 支撑阻力 + 趋势线。不看指标，只看价格本身。\n\n### 2. 三种市场状态\n- **趋势**：一系列更高的高点和低点（或相反）\n- **区间**：价格在支撑和阻力之间来回\n- **突破**：价格突破区间边界，可能开启新趋势\n\n### 3. 核心信号\n- **强势蜡烛**：实体大、影线短，代表动能强\n- **弱势蜡烛**：影线长、实体小，代表犹豫\n- **连续同向**：连续出现同方向的强势蜡烛 = 高概率延续\n\n### 4. 交易框架\n1. 先判断市场状态（趋势/区间/突破）\n2. 在关键位置等待信号\n3. 设置合理的止损和止盈\n4. 管理持仓直到出场条件触发`,
  },
  {
    id: 'market-profile',
    title: '市场轮廓',
    author: 'J·彼得·施泰因迈尔',
    cover: getBookCover('market-profile'),
    difficulty: '进阶',
    summary: '介绍市场轮廓理论，通过成交量和价格分布理解市场结构。',
    highlights: `## 核心精华\n\n### 1. 市场轮廓基础\n市场轮廓将一天的交易按价格和时间排列，形成钟形曲线（正态分布），帮助你看清真正的价值区域。\n\n### 2. 关键概念\n- **价值区域**：70% 的交易量集中在该价格区间\n- **公允价值**：买卖双方最活跃的价格\n- **价格接受者 vs 价格推动者**：谁在主导市场\n\n### 3. 市场的三种日型\n- **正常日**：价格在价值区域内波动\n- **趋势日**：价格持续向一个方向移动，价值区域不断迁移\n- **中性日**：价格在两个极端之间来回\n\n### 4. 实战应用\n- 在价值区域上方做多、下方做空是逆势\n- 等待价格回到价值区域附近再入场更安全\n- 结合成交量分布判断关键支撑/阻力`,
  },
  {
    id: 'turtle-trading',
    title: '海龟交易法则',
    author: '柯蒂斯·费思',
    cover: getBookCover('turtle-trading'),
    difficulty: '进阶',
    summary: '揭秘传奇交易员理查德·丹尼斯的"海龟实验"，将普通人训练成顶级交易员的系统化方法。',
    highlights: `## 核心精华\n\n### 1. 海龟实验\n> 理查德·丹尼斯认为交易可以被教会，就像新加坡的海龟养殖场培养海龟一样。他招募了一批普通人，用一套完整的规则训练他们，结果证明：**系统化交易 > 个人直觉**。\n\n### 2. 核心策略：趋势跟踪\n- 在价格突破 N 日最高价时买入\n- 在价格跌破 N 日最低价时卖出\n- 不预测方向，只跟随趋势\n\n### 3. 仓位管理（ATR 法）\n> 仓位大小 = 账户风险的 1-2% ÷ (ATR × 合约乘数)\n\n- 波动大时减少仓位，波动小时增加仓位\n- 任何时候单笔亏损不超过账户的 2%\n\n### 4. 止损与止盈\n- **止损**：入场后亏损 2 个 ATR 就止损\n- **止盈**：使用移动止损跟踪利润\n- **金字塔加仓**：盈利后可加仓，但每次加仓后要调整止损\n\n### 5. 关键教训\n> 交易成功 = 策略 × 纪律 × 资金管理。三者缺一不可。`,
  },
  {
    id: 'bitcoin-standard',
    title: '比特币本位',
    author: '赛义德·阿莫斯',
    cover: getBookCover('bitcoin-standard'),
    difficulty: '入门',
    summary: '从货币史角度解释比特币的价值，论证其作为"数字黄金"的稀缺性和优越性。',
    highlights: `## 核心精华\n\n### 1. 货币的演变\n> 货币的本质是最畅销的商品。从贝壳 → 黄金 → 法币 → 数字货币，每一次演变都是效率的提升。\n\n### 2. 什么让货币"硬"\n- **硬度** = 货币供给难以被增加\n- 黄金的硬度来自开采成本高\n- 法币的硬度为零（央行随时可以印）\n- 比特币的硬度 = 数学保证的 2100 万枚上限\n\n### 3. 比特币 vs 传统资产\n| 维度 | 法币 | 黄金 | 比特币 |\n|------|------|------|--------|\n| 供给 | 无限 | 有限但可开采 | 绝对有限 |\n| 转移 | 受限 | 困难 | 全球即时 |\n| 存储 | 银行 | 保险柜 | 私钥 |\n| 审查 | 可冻结 | 可没收 | 抗审查 |\n\n### 4. 核心论点\n> 比特币是史上最硬的货币。它的价值不来自政府信用，而来自数学和共识。理解了这一点，就理解了为什么比特币值得长期持有。`,
  },
];

export default books;
